﻿$.fn.dxCtrlGridAnim = function custom_dxCtrlGridAnim(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlgridanim dx-ctrl");
        this.createInstance(new cdxCtrlGridAnim(this, option));
    }
    return this;
}

var idxGridAnim = 0
window.cdxCtrlGridAnim = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid] == 'undefined') option.bddCtrl.utiCourantParaJson[option.context_grid] = {}
    if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid].config_grid_anim == 'undefined') option.bddCtrl.utiCourantParaJson[option.context_grid].config_grid_anim = {}
    if (typeof option.showPager == 'undefined') option.showPager = true

    if (typeof option.showColumnHeaders == 'undefined') option.showColumnHeaders = true
    var idxGridAnimCurrent = idxGridAnim
    idxGridAnim += 1

    var nbTemplateAvant = 50
    var nbTemplateApres = 50
    var columnsGridEntete = []
    option.fields.forEach(function (field) {
        if (field.allowGrid) {
            var column = {
                name: field.name,
                dataField: field.dataField,
                caption: field.caption,
                allowGrouping: field.allowGrouping,
                allowSorting: field.allowSorting,
                groupIndex: field.groupIndex,
                sortIndex: field.sortIndex,
                sortOrder: field.sortOrder,
                showWhenGrouped: true,
                showInColumnChooser: field.showInColumnChooser,
                headerCellTemplate: field.headerCellTemplate,
                calculateGroupValue: field.calculateGroupValue,
                groupCellTemplate: field.groupCellTemplate,
                calculateCellValue: field.calculateCellValue,
                calculateSortValue: field.calculateSortValue,
                cellTemplate: field.cellTemplate,
                visible: field.visible
            }
            columnsGridEntete.push(column)
            if (typeof field.icon != 'undefined' && typeof column.headerCellTemplate == 'undefined') {
                column.headerCellTemplate = function (contentElement) {
                    contentElement.append($("<span style='opacity:0.5;'><i class='" + field.icon + " dx-theme-accent-as-text-color' style='padding-right:3px;opacity:0.5;'></i>" + field.caption + "</span>"));
                    contentElement.parent().attr("title", field.caption)
                }
            }
        }
    })

    var $DivEntete = null
    var dxGridEntete = null
    var dxGridData = null
    var $DivGrid = null
    var dxScrollGrid = null
    var lastScrollTop = 0
    var timeOutScroll = null
    var lstTemplate = []
    var firstLoad = true
    var animCurrent = "rotateInDown"
    animCurrent = "fadeIn"
    var animate = true
    var jaugeGrid = null
    var lstTaille = []
    var template0LoadedForPagination = false
    var idxAnim = 0

    //------------------------------------------------------------------
    // PERF : index des templates (recherche O(1) au lieu de filter O(n))
    //------------------------------------------------------------------
    var mapTemplate = new Map()   // "id_table|id" -> dataTemplate
    function mCleTpl(idTable, id) { return idTable + "|" + id }
    function mIndexTemplate() {
        mapTemplate = new Map()
        for (var i = 0; i < lstTemplate.length; i++) {
            var t = lstTemplate[i]
            var k = mCleTpl(t.id_table_key, t.id_key)
            if (!mapTemplate.has(k)) mapTemplate.set(k, t)   // le premier gagne (comme filter()[0])
        }
    }

    //gestion des templates en cours de chargement (évite les appels getlsttemplategridanim en double)
    var lstTemplatePending = {}     // "id_table|id" -> date de la demande
    var generationTemplate = 0      // invalide les réponses d'un ancien reload
    var DELAI_PENDING_MS = 15000    // sécurité si une requête échoue sans callback
    function mIsPending(idTable, id) {
        var t = lstTemplatePending[mCleTpl(idTable, id)]
        return typeof t != 'undefined' && (Date.now() - t) < DELAI_PENDING_MS
    }

    //------------------------------------------------------------------
    // PERF : file d'attente des cellules en attente de template
    // (remplace le polling setTimeout(10ms) par cellule)
    //------------------------------------------------------------------
    var lstAttenteTemplate = []
    var timerAttente = null
    var DELAI_FILET_SECURITE_MS = 100
    function mAjouteAttente(fn) {
        lstAttenteTemplate.push(fn)
        if (timerAttente == null) timerAttente = window.setTimeout(mNotifyAttente, DELAI_FILET_SECURITE_MS)
    }
    function mReveilleAttente() {
        if (timerAttente != null) window.clearTimeout(timerAttente)
        timerAttente = window.setTimeout(mNotifyAttente, 0)
    }
    function mNotifyAttente() {
        timerAttente = null
        var lst = lstAttenteTemplate
        lstAttenteTemplate = []
        for (var i = 0; i < lst.length; i++) lst[i]()
    }

    //cache de hauteur de ligne par table (évite getObjet à chaque onRowPrepared)
    var cacheHauteurTable = {}

    function mConstruit() {
        container.empty();
        $DivReserve = $("<div style='position:absolute;top:10000px;right:10000px;'/>").appendTo(container)
        container.css("height", "100%")
        jaugeGrid = $("<div/>").appendTo(container).dxCtrlJauge({}).dxCtrlJauge("instance")
        $DivEntete = $("<div style='max-height:50%;'></div>").appendTo(container)
        $DivGrid = $("<div style='height:100%;'/>").appendTo(container)
        dxGridEntete = $("<div/>").appendTo($DivEntete).dxCtrlGridEntete({
            bddCtrl: option.bddCtrl,
            fields: option.fields,
            dataGridVue: option.dataGridVue,
            context_grid: option.context_grid,
            columns: columnsGridEntete,
            allowCheck: option.allowCheck,
            allowColumnReordering: false,
            allowColumnResizing: false,
            allow_columnchooser: option.allow_columnchooser,
            allowGroup: option.allowGroup,
            onGroupSortChanged: onGroupSortChanged,
            onToolbarPreparing: option.onToolbarPreparing,
            onDemandeReloadData: option.onDemandeReloadData,
            showColumnHeaders: option.showColumnHeaders,
            onFirstContentReady: function (e) {
                mConstruitGridData()
            }
        }).dxCtrlGridEntete("instance")
        if (parametre.isMobile || option.hideEntete) {
            $DivEntete.hide()
        }
        window.setTimeout(function () {
            resizeObserver.mAdd($DivEntete, function () {
                if ($DivGrid) {
                    $DivGrid.css({ height: "calc(100% - " + (($DivEntete.is(":visible")) ? $DivEntete.innerHeight() : 0) + "px)" })
                } else {
                    window.setTimeout(function () {
                        if ($DivGrid) {
                            $DivGrid.css({ height: "calc(100% - " + (($DivEntete.is(":visible")) ? $DivEntete.innerHeight() : 0) + "px)" })
                        }
                    }, 500)
                }
            })()
        }, 0)


        $(window).off("changemodepaginationgrille.gridanim" + idxGridAnimCurrent)
        $(window).on("changemodepaginationgrille.gridanim" + idxGridAnimCurrent, function (e) {
            if (typeof option.onDemandeReconstruit != 'undefined') option.onDemandeReconstruit()
        })
    }

    //chargement des templates (une requête par lot)
    function mChargeTemplates(lstIdTableIdToLoad) {
        if (lstIdTableIdToLoad.length == 0) return
        var now = Date.now()
        lstIdTableIdToLoad.forEach(function (o) { lstTemplatePending[mCleTpl(o.id_table, o.id)] = now })
        var generation = generationTemplate

        option.bddCtrl.mAjaxCall({
            command: "getlsttemplategridanim",
            type_data: option.typeData,
            data: lstIdTableIdToLoad,
            is_for_doublon: ((option.isForDoublon) ? "1" : "0")
        }, function (data) {
            lstIdTableIdToLoad.forEach(function (o) { delete lstTemplatePending[mCleTpl(o.id_table, o.id)] })
            if (generation != generationTemplate) return   // réponse d'un ancien mReloadData
            if (typeof data.lstdatatemplate == 'undefined') data.lstdatatemplate = []
            var dcr = new Date()
            data.lstdatatemplate.forEach(function (dataTemplate) {
                dataTemplate.dcr_template = dcr
                var k = mCleTpl(dataTemplate.id_table_key, dataTemplate.id_key)
                if (!mapTemplate.has(k)) {
                    lstTemplate.push(dataTemplate)
                    mapTemplate.set(k, dataTemplate)
                }
            })
            animate = true
            mReveilleAttente()   //les cellules en attente se dessinent tout de suite
        })
    }

    var heightRowRef = null
    function mConstruitGridData() {

        var opt = {
            noDataText: "",
            height: 3000,
            context_grid: option.context_grid,
            columns: mGetColumnGridAnim(),
            summary: {
                groupItems: [{
                    summaryType: 'count',
                }],
            },
            editing: {
                confirmDelete: false
            },
            grouping: { autoExpandAll: true, },
            groupPanel: { visible: false },
            selection: { mode: "none" },
            showBorders: false,
            showRowLines: false,
            showColumnLines: false,
            allowColumnReordering: false,
            allowColumnResizing: false,
            columnChooser: { enabled: false },
            showColumnHeaders: false,
            repaintChangesOnly: true,
            focusStateEnabled: false,
            onRowPrepared(e) {
                if (e.rowType != "data") return
                if (typeof lstTaille[e.data.cle] != 'undefined') { e.rowElement.css({ "max-height": (lstTaille[e.data.cle]) + "px" }) }
                else {
                    if (heightRowRef == null) {
                        if (typeof option.getItemTemplateHeight != 'undefined') {
                            e.rowElement.css({ "height": option.getItemTemplateHeight(option.typeGrille) + "px" })
                        } else {
                            var idTable = e.data.id_table
                            if (idTable <= 0) { e.rowElement.css({ "height": 65 }) }
                            else {
                                if (!(idTable in cacheHauteurTable)) {
                                    var obj = option.bddCtrl.getObjet(option.bddCtrl.table.mGetItem(idTable).nom)
                                    cacheHauteurTable[idTable] = obj.mGetItemTemplateHeight(option.typeGrille)
                                }
                                e.rowElement.css({ "height": cacheHauteurTable[idTable] })
                            }
                        }
                    } else {
                        e.rowElement.css({ "height": heightRowRef + "px" })
                    }
                }
            },
            onOptionChanged: function (e) {
                if (e.name === "paging" && e.fullName === "paging.pageIndex") {
                    idxAnim = 0
                    template0LoadedForPagination = false
                }
            },
            onSelectionChanged: function () { option.onSelectionChanged(Me.mGetLstSelectedData(), Me.mGetLstData()) },
            onContentReady: function (e) {
                dxGridData = e.component
                if (firstLoad) {
                    window.setTimeout(function () { e.component.option("height", "100%"); firstLoad = false; }, 1000)
                }

                if (e.component.option("paging.enabled")) {
                    if (e.component.option("paging.pageSize") != option.bddCtrl.utiCourantParaJson[option.context_grid].pagination_nb_element_par_page) {
                        option.bddCtrl.utiCourantParaJson[option.context_grid].pagination_nb_element_par_page = e.component.option("paging.pageSize")
                        option.bddCtrl.mSaveParaJsonUtilisateur();
                    }
                }

                var lstVisibleRowsData = dxGridData.getVisibleRows().filter(function (o) { return o.rowType == "data" })
                if (lstVisibleRowsData.length > 0) {
                    //on génère la liste des template à récupérer
                    //(on exclut ceux déjà en cours de chargement : onContentReady est appelé plusieurs fois)
                    var lstIdTableIdToLoad = mGetLstIdTableIdForLoadingTemplate(lstVisibleRowsData, "data")
                        .filter(function (o) { return !mIsPending(o.id_table, o.id) })

                    if (lstIdTableIdToLoad.length > 0) {
                        //PERF : les lignes visibles d'abord (petite requête => réponse rapide),
                        //puis le préchargement avant/après dans une 2e requête
                        var setVisible = new Set()
                        lstVisibleRowsData.forEach(function (r) { setVisible.add(mCleTpl(r.data.id_table, r.data.id)) })
                        var lstPrio = []
                        var lstPrechargement = []
                        lstIdTableIdToLoad.forEach(function (o) {
                            if (setVisible.has(mCleTpl(o.id_table, o.id))) { lstPrio.push(o) } else { lstPrechargement.push(o) }
                        })
                        mChargeTemplates(lstPrio)
                        mChargeTemplates(lstPrechargement)
                    }
                }

                if (typeof dxScrollGrid == 'undefined' || dxScrollGrid == null) {
                    dxScrollGrid = e.component.getScrollable()
                    if (typeof dxScrollGrid != 'undefined' && dxScrollGrid != null) {
                        var onScroll = dxScrollGrid.option("onScroll")
                        dxScrollGrid.option("onScroll", function (e) {
                            lastScrollTop = dxScrollGrid.scrollTop()
                            window.clearTimeout(timeOutScroll)
                            timeOutScroll = window.setTimeout(function () {
                                animate = ((typeof e.animate != 'undefined') ? e.animate : true)
                                idxAnim = 0
                                onScroll(e)
                            }, 200)
                        })
                    }
                }

                window.setTimeout(function () {
                    if (typeof option.noDataText != 'undefined') {
                        var $noData = $(e.component.element().find(".dx-datagrid-nodata"))
                        var mAppliqueNoData = function () {
                            if ($.isFunction(option.noDataText)) { option.noDataText($noData) } else { $noData.html(option.noDataText) }
                        }
                        mAppliqueNoData()
                        if (Me.mGetLstData().length > 0) {
                            $noData.addClass("dx-hidden")
                        } else {
                            window.setTimeout(function () {
                                mAppliqueNoData()
                                $noData.show()
                                window.setTimeout(function () {
                                    mAppliqueNoData()
                                    $noData.show()
                                }, 250)
                            }, 500)
                            $noData.show()
                        }
                    }
                }, 100)

                if (firstLoad) {
                    if (typeof option.onFirstContentReady != 'undefined') option.onFirstContentReady(e)
                    if (parametre.isMobile || option.hideEntete) e.component.element().find(".dx-bordered-top-view").css("border-top", "none")
                }
                if (typeof option.onSelectionChanged != 'undefined') option.onSelectionChanged(Me.mGetLstSelectedData(), Me.mGetLstData())
                firstLoad = false
            }
        }

        opt.scrolling = {
            "useNative": option.bddCtrl.utiCourantParaJson.parametre_general.scroll_use_native
        }
        if (option.bddCtrl.utiCourantParaJson.parametre_general.pagination_grille && parametre.isDesktop && !option.noPagination) {
            if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid].pagination_nb_element_par_page == 'undefined') option.bddCtrl.utiCourantParaJson[option.context_grid].pagination_nb_element_par_page = 50
            opt.scrolling.rowRenderingMode = 'standard'
            opt.paging = {
                enabled: true,
                pageSize: option.bddCtrl.utiCourantParaJson[option.context_grid].pagination_nb_element_par_page,
            }
            opt.pager = {
                visible: option.showPager,
                allowedPageSizes: [20, 30, 50, 80, 100],
                showPageSizeSelector: true,
                showInfo: true,
                showNavigationButtons: true,
            }
        } else {
            opt.scrolling = { mode: 'Virtual', preloadEnabled: true, rowRenderingMode: 'virtual' }
            opt.paging = { enabled: false }
        }
        dxGridData = $("<div style='height:100%;'/>").appendTo($DivGrid).dxDataGrid(opt).dxDataGrid("instance")
    }

    var nbBoucleDrawLigne = 0
    function mGetColumnGridAnim() {
        var lstCol = []
        Me.mGetLstFieldGrpSort().forEach(function (col) {
            var field = option.fields.filter(function (field) { return field.dataField == col.field.dataField })[0]
            var colAnim = {
                name: col.field.name,
                dataField: col.field.dataField,
                sortOrder: col.sortOrder,
                visible: false,
                showWhenGrouped: false,
                showInColumnChooser: field.showInColumnChooser,
                headerCellTemplate: field.headerCellTemplate,
                calculateGroupValue: field.calculateGroupValue,
                groupCellTemplate: field.groupCellTemplate,
                calculateCellValue: field.calculateCellValue,
                calculateSortValue: field.calculateSortValue,
                cellTemplate: field.cellTemplate
            }
            if (typeof col.groupIndex != 'undefined') {
                colAnim.groupIndex = col.groupIndex
            } else if (typeof col.sortIndex != 'undefined') {
                colAnim.sortIndex = col.sortIndex
            }
            lstCol.push(colAnim)
        })
        //rowTemplate
        lstCol.push({
            name: "rowtemplate",
            headerCellTemplate: function () {
                return ""
            },
            //PERF : clé de version légère au lieu de JSON.stringify(rowData)
            //repaintChangesOnly compare cette valeur pour savoir si la cellule doit être redessinée
            calculateCellValue: function (rowData) {
                if (!('dmoupdate' in rowData)) return JSON.stringify(rowData)   //repli si le champ n'existe pas
                var dmo = rowData.dmoupdate
                if (dmo instanceof Date) dmo = dmo.getTime()
                return rowData.cle + "|" + ((dmo == null) ? "" : dmo)
            },
            cellTemplate(container, options) {
                container.css("padding", "3px")
                container.css("overflow", "visible")
                container.css("position", "relative")
                container.addClass("td_fake_height")

                container.attr("idele", options.data.id)
                container.attr("idtable", options.data.id_table)

                container.addClass("divgridcontent")
                mLoad()
                function mLoad() {
                    if (container.closest("body").length == 0) return   //cellule détruite : on abandonne
                    var dataTemplate = mGetTemplateBase(options.data)
                    var idxPremiereLigne = ((options.component.getDataSource().group() == null) ? 0 : options.component.getDataSource().group().length)
                    if (typeof dataTemplate == 'undefined' ||
                        (options.rowIndex != idxPremiereLigne && !template0LoadedForPagination)) {
                        if (container.find(".panelload").length == 0) {
                            var alignItem = "left"
                            if (typeof option.getAlignItem != 'undefined') {
                                alignItem = option.getAlignItem(options.data)
                            } else if (options.data.id_table > 0) { //pas un fichier
                                var obj = option.bddCtrl.getObjet(option.bddCtrl.table.mGetItem(options.data.id_table).nom)
                                if (obj.objetMetier != null && typeof obj.objetMetier.alignItemGrid != 'undefined' && obj.objetMetier.alignItemGrid == "right") alignItem = "right"
                            }
                            container.css("text-align", alignItem)
                            if (alignItem == "left") { alignItem = "right" } else { alignItem = "left" }
                            var diff = Math.random() * 30;
                            $("<div style='width:" + (100 - diff) + "%;" + ((alignItem == "right") ? "left:0;" : "right:0;") + "height:calc(100% - 10px);z-index:0;top:5px;animation:colordatagridload 1.5s infinite linear;position:absolute;display:inline-block;margin:2px 22px;margin-" + alignItem + ":" + (diff) + "%;' class='panelload'>&nbsp;</div>").appendTo(container)
                        }
                        //PERF : on attend la notification (arrivée des templates / ligne 0 dessinée)
                        //au lieu de reboucler toutes les 10 ms
                        mAjouteAttente(mLoad)
                    } else {
                        container.find(".panelload").remove()
                        var etaitCharge = template0LoadedForPagination
                        template0LoadedForPagination = true
                        idxAnim += 1
                        mDrawRowCell(container, options.data, idxAnim)
                        //la ligne 0 vient d'être dessinée : on débloque les autres immédiatement
                        if (!etaitCharge && lstAttenteTemplate.length > 0) mReveilleAttente()
                    }
                }

            }
        })
        return lstCol
    }

    this.mChangeSelectAll = function (selectAll) {
        if (typeof selectAll != 'undefined') {
            if (selectAll) { dxGridData.selectAll() }
            else { dxGridData.deselectAll() }
        } else {
            if (Me.mGetLstSelectedData().length != Me.mGetLstData().length) {
                dxGridData.selectAll()
            } else {
                dxGridData.deselectAll()
            }
        }
    }

    this.mGetModeSelection = function () {
        return ((dxGridData) ? dxGridData.option("selection.mode") : "none")
    }
    this.mSwitchCheck = function () {
        if (dxGridData) dxGridData.option("selection.mode", ((dxGridData.option("selection.mode") == "none") ? "multiple" : "none"))
        mTraiteCheckBox()
    }

    //PERF : regroupé en un seul passage par frame (au lieu d'un scan complet du DOM par ligne dessinée)
    var rafCheckBox = null
    function mTraiteCheckBox() {
        if (rafCheckBox != null) return
        rafCheckBox = window.requestAnimationFrame(function () {
            rafCheckBox = null
            mTraiteCheckBoxMaintenant()
        })
    }

    function mTraiteCheckBoxMaintenant() {
        var lstDx = []
        container.find(".dx-select-checkbox:not(.ga-chk-init)").each(function (idx, ele) {
            var dxChk = $(ele).dxCheckBox("instance")
            if (dxChk) lstDx.push(dxChk)
        })
        lstDx.forEach(function (dxChk) {
            if (!dxChk.initialized) {
                var valChanged = dxChk.option("onValueChanged")
                dxChk.option("onValueChanged", function (e) {
                    if (typeof e.event == 'undefined') return;
                    if (e.event.shiftKey) {
                        var cle = e.element.closest(".dx-data-row").attr("cle")
                        var lstSelectedData = Me.mGetLstSelectedData()
                        var checkedData = lstCurrentData.filter(function (o) { return o.cle == cle })[0]
                        var idxChecked = lstCurrentData.indexOf(checkedData)
                        if (e.value) {
                            //on regarde si on a un élément checké au dessus
                            var lstCleEnDessus = []
                            var dataCheckedPlusProcheTop = null
                            for (let i = idxChecked; i >= 0; i--) {
                                lstCleEnDessus.push(lstCurrentData[i].cle)
                                if (lstSelectedData.contains(lstCurrentData[i])) {
                                    dataCheckedPlusProcheTop = lstCurrentData[i]
                                    break;
                                }
                            }
                            if (dataCheckedPlusProcheTop != null) {
                                lstSelectedData.forEach(function (gridData) {
                                    if (lstCleEnDessus.filter(function (cle) { return cle == gridData.cle }).length == 0) lstCleEnDessus.push(gridData.cle)
                                })
                                dxGridData.selectRows(lstCleEnDessus)
                            } else {
                                var lstCleEnDessous = []
                                var dataCheckedPlusProcheBottom = null
                                for (let i = idxChecked; i < lstCurrentData.length; i++) {
                                    lstCleEnDessous.push(lstCurrentData[i].cle)
                                    if (lstSelectedData.contains(lstCurrentData[i])) {
                                        dataCheckedPlusProcheBottom = lstCurrentData[i]
                                        break;
                                    }
                                }
                                if (dataCheckedPlusProcheBottom != null) {
                                    lstSelectedData.forEach(function (gridData) {
                                        if (lstCleEnDessous.filter(function (cle) { return cle == gridData.cle }).length == 0) lstCleEnDessous.push(gridData.cle)
                                    })
                                    dxGridData.selectRows(lstCleEnDessous)
                                } else {
                                    valChanged(e)
                                }
                            }
                        }
                    } else {
                        valChanged(e)
                    }
                })
                dxChk.initialized = true
            }
            dxChk.element().addClass("ga-chk-init")
        })
    }

    function mDrawRowCell(container, dataGrid, idx) {
        //container.addClass("ph-no-capture")
        var $Div = $("<div style='height:100%;z-index:10;'/>").appendTo(container)
        container.closest(".dx-data-row").attr("cle", dataGrid.cle)
        var templateBase = mGetTemplateBase(dataGrid)
        if (parametre.isMobile) {
            $Div.css("padding", "0")
            $Div.parent().css("padding", "0")
            var lstBtLeft = []
            var lstBtRight = []
            if (typeof option.onDisplayButtonLigne != 'undefined') {
                var toolbar = $("<div style='background-color:transparent'/>").dxToolbar({
                }).dxToolbar("instance")
                option.onDisplayButtonLigne(toolbar, dataGrid, templateBase)
                toolbar.option("items").filter(function (o) { return typeof o.mobile != 'undefined' }).sort(function (o1, o2) {
                    return o1.mobile.index - o2.mobile.index
                }).forEach(function (o) {
                    if (o.mobile.position == "right") {
                        lstBtRight.push({
                            icon: o.options.icon,
                            text: o.options.text,
                            color: o.mobile.color,
                            onClick: function () {
                                o.options.onClick()
                            }
                        })
                    } else {
                        lstBtLeft.push({
                            icon: o.options.icon,
                            text: o.options.text,
                            color: o.mobile.color,
                            onClick: function () {
                                o.options.onClick()
                            }
                        })
                    }
                })
            }
            var contentDisplay = null
            $("<div style='width:100%;height:100%;padding:10px;background-color:" + ((typeof option.grilleBackgroundColor == "undefined") ? theme.grilleBackgroundColor : option.grilleBackgroundColor) + ";' class='divtemplate'/>").appendTo($Div).dxCtrlSwipe({
                leftButtons: lstBtLeft,
                rightButtons: lstBtRight,
                contentTemplate: function (contentElement) {
                    contentDisplay = contentElement
                    var templateDisplay = mGetTemplateDisplay(dataGrid)
                    var optionTemplate = {}
                    if (typeof option.optionTemplate != 'undefined') optionTemplate = JSON.parse(JSON.stringify(option.optionTemplate))
                    optionTemplate.dataGrid = dataGrid
                    optionTemplate.dataGridVue = option.dataGridVue
                    optionTemplate.fields = option.fields
                    optionTemplate.typeDisplay = "grille"
                    optionTemplate.onChange = ((option.readOnly) ? null : function (idTypeChamp, dataTemlate) { })
                    optionTemplate.onChanged = ((option.readOnly) ? null : function (idTypeChamp, dataTemlate) { onChange(idTypeChamp, dataTemlate) })
                    if (typeof option.itemTemplateGrille == 'undefined') {
                        var objBase = null
                        if (templateDisplay.id_table_key == 0) {
                            objBase = new cObjetFile(templateDisplay, option.bddCtrl)
                        } else {
                            objBase = option.bddCtrl.getObjet(option.bddCtrl.table.mGetItem(templateDisplay.id_table_key).nom)
                        }
                        objBase.itemTemplateGrille(contentElement, templateDisplay, option.typeGrille, optionTemplate)
                    } else {
                        option.itemTemplateGrille(contentElement, templateDisplay, option.typeGrille, optionTemplate)
                    }
                },
                onContentReady: function (component) {
                    contentDisplay.css("opacity", component.element().css("opacity"))
                    component.element().css("opacity", "1")
                }
            })
            if (typeof option.onClickDataGrid == 'undefined') {
                $Div.css("cursor", "default")
            } else {
                if (option.readOnly) {
                    $Div.on("click", function () {
                        option.onClickDataGrid(container, dataGrid, mGetTemplateBase(dataGrid))
                    })
                    $Div.css("cursor", "pointer")
                    container.css("border-bottom", theme.border)
                } else {
                    $Div.css("border", "1px dashed " + theme.color)
                }
            }

        } else {
            if (!option.hideRound) {
                $Div.css("padding-right", ((option.paddingLeftRightRow) ? option.paddingLeftRightRow : "5%"))
                $Div.css("padding-left", ((option.paddingLeftRightRow) ? option.paddingLeftRightRow : "5%"))
            }
            var alignItem = "left"
            if (typeof dataGrid.align != 'undefined') {
                if (dataGrid.align == "1") alignItem = "right"
            } else if (typeof option.getAlignItem != 'undefined') {
                alignItem = option.getAlignItem(dataGrid)
            } else {
                var obj = null
                obj = option.bddCtrl.getObjet(option.bddCtrl.table.mGetItem(dataGrid.id_table).nom)
                if (dataGrid.id_table != "0" && dataGrid.id_table != "9999" && obj != null && typeof obj.objetMetier != 'undefined' && obj.objetMetier != null && typeof obj.objetMetier.alignItemGrid != 'undefined' && obj.objetMetier.alignItemGrid == "right") {
                    alignItem = "right"
                }
            }

            var $DivContainer = $("<div style='width:100%;height:100%;position:relative;padding:2px 0;' class='itemgrid' idele='" + dataGrid.id + "' id_table='" + dataGrid.id_table + "'/>").appendTo($Div)
            var $DivTemplate = $("<div style='height:100%;background-color:" + ((typeof option.grilleBackgroundColor == "undefined") ? theme.grilleBackgroundColor : option.grilleBackgroundColor) + ";border-radius:5px;" + ((option.hideRound) ? "margin:0;padding:2px 5px;" : "padding:2px 22px;margin:0 15px;") + "' class='divtemplate'/>").appendTo($DivContainer)

            //traitement round
            var $DivRound = $("<div style='position:absolute;top:50%;transform: translateY(-50%);border-radius:50%;box-shadow:0 0 0 1px " + theme.color + ";display:flex;align-items:center;justify-content:center;background-color:" + theme.backgroundcolorTooltip.replace("rgb(", "rgba(").replace(")", ",0.3)") + ";overflow:hidden;' class='divround'/>").appendTo($DivContainer)
            if (option.hideRound) $DivRound.css("display", "none")

            var positionRightLeft = "-5px"
            if (option.typeGrille == "Lignes" && option.typeData != "strcon") {
                $DivRound.css({ "width": "24px", "height": "24px", "font-size": "14px" })
                positionRightLeft = "5px"
            } else {
                $DivRound.css({ "width": "40px", "height": "40px", "font-size": "28px" })
                positionRightLeft = "-5px"
            }
            switch (alignItem) {
                case "left":
                    $DivRound.css("left", positionRightLeft);
                    break;
                case "right":
                    $DivRound.css("right", positionRightLeft);
                    break;
            }
            $DivRound.css("animation-delay", "0.2s")
            if (typeof option.itemTemplateIco == 'undefined') {
                var templateIco = mGetTemplateIco(dataGrid)
                if (templateIco.id_table_key == "0") {
                    (new cObjetFile(templateIco, option.bddCtrl)).mGetIcone(templateIco).appendTo($DivRound)
                } else {
                    if (typeof templateIco.id_table_key != 'undefined') {
                        option.bddCtrl.getObjet(option.bddCtrl.table.mGetItem(templateIco.id_table_key).nom).mGetIcone(templateIco).appendTo($DivRound)
                    } else {
                        option.bddCtrl.getObjet(option.bddCtrl.getObjet(templateIco).mGetTable().nom).mGetIcone(templateIco).appendTo($DivRound)
                    }
                }
            } else { option.itemTemplateIco($DivRound, templateBase) }

            if (option.typeData == "strcon" && option.allowModifTemplateStrCon && option.bddCtrl.objCptCli.objetMetier.hasVueTemplate() && !option.hideEntete && option.showColumnHeaders) {
                if (typeof option.onClickDataGrid != 'undefined') {
                    var txt = ""
                    switch (option.bddCtrl.table.mGetItem(dataGrid.id_table).nom) {
                        case "structures": txt = "Modifier la présentation des données<br/>des structures dans la grille"; break;
                        case "structures_contact": txt = "Modifier la présentation des données<br/>des structures/contacts dans la grille"; break;
                        case "contact": txt = "Modifier la présentation des données<br/>des contacts dans la grille"; break;
                        default: break;
                    }
                    if (option.readOnly) { txt += " de VISUALISATION" }
                    else { txt += " de MODIFICATION" }
                    if (txt.length > 0) {
                        //PERF : bouton créé au premier survol seulement
                        var dxBtModif = null
                        $DivContainer.on("mouseenter", function () {
                            if (dxBtModif == null) {
                                dxBtModif = $("<div style='position:absolute;top:0;'/>").appendTo($DivContainer).dxCtrlButton({
                                    icon: "fas fa-pen-ruler",
                                    hint: txt,
                                    height: 26,
                                    width: 26,
                                    onClick: function (e) {
                                        var dataTemplateForm = null
                                        if (option.readOnly) {
                                            dataTemplateForm = option.bddCtrl.getObjet("template_form").objetMetier.mGetDataVisu(option.dataGridVue.id_grid_vue, option.bddCtrl.table.mGetItem(dataGrid.id_table).nom)
                                        } else {
                                            dataTemplateForm = option.bddCtrl.getObjet("template_form").objetMetier.mGetDataModif(option.dataGridVue.id_grid_vue, option.bddCtrl.table.mGetItem(dataGrid.id_table).nom)
                                        }

                                        $("<div/>").appendTo("body").dxCtrlGridTemplate({
                                            bddCtrl: option.bddCtrl,
                                            readOnly: option.readOnly,
                                            dataGridVue: option.dataGridVue,
                                            typeDisplay: "grille",
                                            table: option.bddCtrl.table.mGetItem(dataGrid.id_table),
                                            dataTemplate: mGetTemplateBase(dataGrid),
                                            dataTemplateForm: dataTemplateForm,
                                            onClose: function () {
                                                option.onDemandeReloadData()
                                            }
                                        })
                                    }
                                }).dxCtrlButton("instance")
                            }
                            dxBtModif.element().show()
                        })
                        $DivContainer.on("mouseleave", function () {
                            if (dxBtModif != null) dxBtModif.element().hide()
                        })
                    }
                }
            }

            if (idx == -1) {
                $DivRound.show()
            } else {
                $DivRound.css("--animate-duration", "0.6s")
                $DivRound.css("animation-delay", (idx * 0.02) + "s")
                animateCSS($DivRound, "zoomIn")
            }

            try {
                var templateDisplay = mGetTemplateDisplay(dataGrid)
                templateDisplay.$DivTemplate = $DivTemplate
                templateDisplay.alignItem = alignItem
                var optionTemplate = {}
                if (typeof option.optionTemplate != 'undefined') optionTemplate = JSON.parse(JSON.stringify(option.optionTemplate))
                optionTemplate.dataGrid = dataGrid
                optionTemplate.dataGridVue = option.dataGridVue
                optionTemplate.fields = option.fields
                optionTemplate.typeDisplay = "grille"
                optionTemplate.onChange = ((option.readOnly) ? null : function (idTypeChamp, dataTemlate) { })
                optionTemplate.onChanged = ((option.readOnly) ? null : function (idTypeChamp, dataTemlate) { onChange(idTypeChamp, dataTemlate) })
                $("<div style=''/>").appendTo($DivTemplate).dxCtrlItemGridTemplate({
                    bddCtrl: option.bddCtrl,
                    optionGrid: option,
                    alignItem: alignItem,
                    typeGrille: option.typeGrille,
                    dataGrid: dataGrid,
                    dataGridVue: option.dataGridVue,
                    itemTemplateGrille: option.itemTemplateGrille,
                    itemTemplateGrillePlus: option.itemTemplateGrillePlus,
                    dataTemplateDisplay: templateDisplay,
                    dataTemplatePlus: mGetTemplatePlus(dataGrid),
                    optionTemplate: optionTemplate
                })
            } catch (e) {
                mTraiteMessageJs("erreurjs", e.message, $(location).attr("href"), 0, null, e, "orange")
            }

            if (typeof option.onHoverDataGrid != 'undefined') {
                $DivTemplate.css("position", "relative")
                var $DivHover = $("<div style='background-color:" + theme.backgroundcolorTooltip.replace("rgb(", "rgba(").replace(")", ",0.3)") + ";width:100%;height:100%;position:absolute;top:0;left:0;z-index:100;opacity:0.8;display:none;'/>").appendTo($DivTemplate)
                $DivTemplate.off("mouseenter")
                $DivTemplate.on("mouseenter", function () {
                    option.onHoverDataGrid($DivHover, dataGrid)
                    $DivHover.show()
                })
                $DivTemplate.off("mouseleave")
                $DivTemplate.on("mouseleave", function () { $DivHover.hide() })
            } else if (typeof option.onDisplayButtonLigne != 'undefined' && option.onDisplayButtonLigne != null) {
                var $DivCmd = $("<div style='position:absolute;top:-28px;right:30px;z-index:10;' class='divcmd'/>").appendTo($DivTemplate)
                if (option.bddCtrl.theme.contains(".light")) $DivCmd.css("top", "-20px")
                if (parametre.isDesktop) {
                    $DivCmd.hide()
                    $DivTemplate.off("mouseenter")
                    $DivTemplate.on("mouseenter", function () {
                        $DivCmd.empty()
                        var toolbar = $("<div style='background-color:transparent'/>").appendTo($DivCmd).dxToolbar({
                            rtlEnabled: true,
                            width: "100%"
                        }).dxToolbar("instance")
                        var dtTemp = mGetTemplateBase(dataGrid)
                        if (typeof dtTemp != 'undefined') option.onDisplayButtonLigne(toolbar, dataGrid, dtTemp)
                        $DivCmd.show(100)
                    })
                    $DivTemplate.off("mouseleave")
                    $DivTemplate.on("mouseleave", function () { $DivCmd.hide(200) })
                } else {
                    var toolbar = $("<div style='background-color:transparent'/>").appendTo($DivCmd).dxToolbar({
                        rtlEnabled: true,
                        width: "100%"
                    }).dxToolbar("instance")
                    option.onDisplayButtonLigne(toolbar, dataGrid, templateBase)
                    $DivCmd.show(100)
                }
            }
            if (typeof option.onClickDataGrid == 'undefined') {
                $DivTemplate.css("cursor", "default")
                $DivRound.css("cursor", "default")
            } else {
                if (option.readOnly) {
                    $DivTemplate.addClass("state-hover")
                    mInitTrackingClickAndDrag($DivTemplate, function () { option.onClickDataGrid(container, dataGrid, mGetTemplateBase(dataGrid)); })
                    $DivTemplate.css("cursor", "pointer")
                } else {
                    if (option.bddCtrl.theme.contains(".light")) { $DivTemplate.css("border", "3px dashed " + theme.color) }
                    else { $DivTemplate.css("border", "1px dashed " + theme.color) }
                }
                $DivRound.css("cursor", "pointer")
                $DivRound.on("click", function () { option.onClickDataGrid(container, dataGrid, mGetTemplateBase(dataGrid)) })
                $DivRound.addClass("state-hover")
            }
        }


        if (animate && option.bddCtrl.utiCourantParaJson.parametre_general.animation_grille && idx != -1 && parametre.isDesktop) {
            var $panel = $(container.find(".panelload")[0])
            if ($panel.length > 0) {
                if (alignItem == "right") { $panel.animate({ width: "0%", "left": "100%" }, 200, function () { $panel.remove() }) }
                else { $panel.animate({ width: "0%", "right": "100%" }, 200, function () { $panel.remove() }) }
            }
            $Div.css("--animate-duration", "0.1s")
            $Div.css("animation-delay", "0s")
            var animToDo = animCurrent
            var alignAnim = ((dataGrid.id_table != "0" && dataGrid.id_table != "9999" && obj != null && typeof obj.objetMetier != 'undefined' && obj.objetMetier != null && typeof obj.objetMetier.alignItemGrid != 'undefined') ? obj.objetMetier.alignItemGrid : "left")
            switch (animToDo) {
                case "rotateInDown":
                    switch (alignAnim) {
                        case "right": animToDo += "Right"; break;
                        case "left": animToDo += "Left"; break;
                    }
                    break;
                case "fadeIn": case "bounceIn": case "slideIn": case "backIn":
                    switch (alignAnim) {
                        case "right": animToDo += "Down"; break;
                        case "left": animToDo += "Up"; break;
                    }
            }
            animateCSS($Div, animToDo).then((message) => {
                $Div.closest(".dx-row").find(".dx-command-select").css("opacity", 1)
                if (option.typeData == "strcon") heightRowRef = $Div.closest(".dx-data-row").innerHeight() + 2
                lstTaille[dataGrid.cle] = container.closest(".dx-data-row").innerHeight()
            });
        } else {
            $Div.closest(".dx-row").find(".dx-command-select").css("opacity", 1)
            container.find(".panelload").remove()
            //PERF : la mesure (reflow forcé) est différée hors du rendu
            window.requestAnimationFrame(function () {
                lstTaille[dataGrid.cle] = container.closest(".dx-data-row").innerHeight()
            })
        }

        mTraiteCheckBox()
    }

    //on a modifié un datatemplate dans la grille
    //on met à jour les template lié (strcon si str ou con)
    function onChange(dataTemplate) {
        var lstIdTableIdToLoad = [{ id_table: dataTemplate.id_table, id: dataTemplate.id }]
        if (option.bddCtrl.table.mGetItemFromNom("structures").id_table == dataTemplate.id_table) {
            //on est sur un structure
            lstTemplate.filter(function (dt) { return dt.id_str == dataTemplate.id }).forEach(function (dt) {
                if (lstIdTableIdToLoad.filter(function (o) { return o.id == dt.id && o.id_table == dt.id_table }).length == 0) lstIdTableIdToLoad.push({ id_table: dt.id_table, id: dt.id })
            })
        } else if (option.bddCtrl.table.mGetItemFromNom("structures_contact").id_table == dataTemplate.id_table) {
            //on est sur un strcon
            lstTemplate.filter(function (dt) { return dt.id == dataTemplate.id_str && dt.id_table == option.bddCtrl.table.mGetItemFromNom("structures").id_table }).forEach(function (dt) {
                if (lstIdTableIdToLoad.filter(function (o) { return o.id == dt.id && o.id_table == dt.id_table }).length == 0) lstIdTableIdToLoad.push({ id_table: dt.id_table, id: dt.id })
            })
            lstTemplate.filter(function (dt) { return dt.id_str == dataTemplate.id_str && dt.id_table == option.bddCtrl.table.mGetItemFromNom("structures_contact").id_table }).forEach(function (dt) {
                if (lstIdTableIdToLoad.filter(function (o) { return o.id == dt.id && o.id_table == dt.id_table }).length == 0) lstIdTableIdToLoad.push({ id_table: dt.id_table, id: dt.id })
            })
        }

        var lstIdChampTableString = ""
        if (typeof option != 'undefined' && typeof option.dataGridVue != 'undefined' && option.dataGridVue != null) {
            lstIdChampTableString = option.bddCtrl.getObjet(option.dataGridVue).objetMetier.mGetLstIdChampTableString(option.readOnly, "grille")
        }
        option.bddCtrl.mAjaxCall({
            command: "getlsttemplategridanim",
            type_data: option.typeData,
            data: lstIdTableIdToLoad,
            lst_id_champ_table: lstIdChampTableString,
            is_for_doublon: ((option.isForDoublon) ? "1" : "0")
        }, function (data) {
            if (typeof data.lstdatatemplate == 'undefined') data.lstdatatemplate = []
            data.lstdatatemplate.forEach(function (item) {
                item.dcr_template = new Date()
            })
            data.lstdatatemplate.forEach(function (dataTemplate) {
                lstTemplate.push(dataTemplate)
            })
            var lstTemplateToUpdate = []
            data.lstdatatemplate.forEach(function (dataTemplate) {
                var oldDataTemplate = lstTemplate.filter(function (o) { return o.id == dataTemplate.id && o.id_table == dataTemplate.id_table })[0]
                if (typeof oldDataTemplate != 'undefined') {
                    dataTemplate.$TdDetail = oldDataTemplate.$TdDetail
                    dataTemplate.alignItem = oldDataTemplate.alignItem
                    lstTemplate[lstTemplate.indexOf(oldDataTemplate)] = dataTemplate
                    lstTemplateToUpdate.push(dataTemplate)
                }
            })
            mIndexTemplate()

            lstTemplateToUpdate.forEach(function (dataTemplate) {
                try {
                    dataTemplate.$TdDetail.empty()
                    $("<div/>").appendTo(dataTemplate.$TdDetail).dxCtrlItemGridTemplate({
                        bddCtrl: option.bddCtrl,
                        alignItem: dataTemplate.alignItem,
                        typeGrille: option.typeGrille,
                        optionGrid: option,
                        dataGrid: dataGrid,
                        dataGridVue: option.dataGridVue,
                        itemTemplateGrille: option.itemTemplateGrille,
                        itemTemplateGrillePlus: option.itemTemplateGrillePlus,
                        dataTemplateDisplay: dataTemplate,
                        dataTemplatePlus: dataTemplate,
                        optionTemplate: {
                            dataGridVue: option.dataGridVue,
                            fields: option.fields,
                            typeDisplay: "grille",
                            onChange: ((option.readOnly) ? null : function (dataTemplate) { onChange(dataTemplate) })
                        }
                    })
                } catch (e) {
                    mTraiteMessageJs("erreurjs", e.message, $(location).attr("href"), 0, null, e, "orange")
                }
            })

        })
    }

    function onGroupSortChanged(newState, lstFieldGrpSort) {
        if (dxGridData) {
            //on vide les datas de la grid
            dxGridData.element().find(".dx-datagrid-nodata").hide()
            dxGridData.option("dataSource", [])
            //on applique le nouvelle état sur la grille
            dxGridData.option("columns", mGetColumnGridAnim())
        }
        //on modifie les filtres de la grille
        option.onDemandeReloadData()
        window.setTimeout(function () { if (dxGridData) dxGridData.element().find(".dx-datagrid-nodata").show() }, 1000)
    }

    this.mGetLstFieldGrpSort = function () {
        return dxGridEntete.mGetLstFieldGrpSort()
    }
    this.mGetToolbar = function () {
        return dxGridEntete.mGetToolbar()
    }

    this.mRemoveRows = function (lstDataGrid) {
        const ds = dxGridData.getDataSource();
        const store = ds.store();

        dxGridData.beginUpdate();

        Promise.all(lstDataGrid.map(item => store.remove(item.cle)))
            .then(() => ds.reload())
            .finally(() => dxGridData.endUpdate());
    }
    this.mRemoveRow = function (dataGrid) {
        dxGridData.deleteRow(dxGridData.getRowIndexByKey(dataGrid.cle))
    }
    this.mRepaintRow = function (dataGrid, rechargeTemplate) {
        if (rechargeTemplate) mDeleteTemplate(dataGrid)
        dxGridData.repaintRows([dxGridData.getRowIndexByKey(dataGrid.cle)])
    }

    this.mUpdateData = function (action, idTable, id) {
        idxAnim = 0
        template0LoadedForPagination = true
        if (typeof action != 'undefined' && typeof idTable != 'undefined') {
            //si on a un éléments, on met à jour l'élément
            switch (action) {
                case "modif":
                    if (lstCurrentData == null) lstCurrentData = []
                    if ($.isArray(idTable)) {
                        idTable.forEach(function (idTableId) {
                            var dataGrid = lstCurrentData.filter(function (o) { return o.cle == idTableId.id + "_" + idTableId.idTable })[0]
                            if (typeof dataGrid != 'undefined') dataGrid.dmoupdate = null
                        })
                    } else {
                        var dataGrid = lstCurrentData.filter(function (o) { return o.cle == id + "_" + idTable })[0]
                        if (typeof dataGrid != 'undefined') dataGrid.dmoupdate = null
                    }
                    break;
                default:
                    //on a supprimer une ligne
                    //on a ajouter une ligne
                    break;
            }
            mUpdateAllData()
        } else { mUpdateAllData() }
    }

    function mUpdateAllData() {
        idxAnim = 0
        template0LoadedForPagination = true
        option.onDemandeData(function (newLstData) {
            if (lstCurrentData == null) lstCurrentData = []

            var param = {
                fn: function (lstCurrentData, newLstData) {
                    const lstOldCleProp = new Map()
                    for (let i = 0; i < lstCurrentData.length; i++) {
                        lstOldCleProp.set(lstCurrentData[i].cle, lstCurrentData[i])
                    }

                    const lstNewCleProp = new Map()
                    for (let i = 0; i < newLstData.length; i++) {
                        lstNewCleProp.set(newLstData[i].cle, newLstData[i])
                    }

                    const lstChange = []

                    // Suppressions et updates
                    for (let i = 0; i < lstCurrentData.length; i++) {
                        const currentData = lstCurrentData[i]
                        const newData = lstNewCleProp.get(currentData.cle)
                        if (!newData) {
                            lstChange.push({ type: "remove", key: currentData.cle })
                        } else if (!areEqual(currentData, newData)) {
                            lstChange.push({ type: "update", data: newData, key: currentData.cle })
                        }
                    }

                    // Insertion
                    for (let i = 0; i < newLstData.length; i++) {
                        const newData = newLstData[i]
                        if (!lstOldCleProp.has(newData.cle)) {
                            lstChange.push({ type: "insert", data: newData })
                        }
                    }

                    return { lstChange: lstChange }

                    function areEqual(obj1, obj2) {
                        const keys1 = Object.keys(obj1)
                        const keys2 = Object.keys(obj2)
                        if (keys1.length !== keys2.length) return false
                        for (let i = 0; i < keys1.length; i++) {
                            const key = keys1[i]
                            if (obj1[key] !== obj2[key]) return false
                        }
                        return true
                    }
                },
                args: [lstCurrentData, newLstData]
            }

            vkthread.exec(param).then(
                function (data) {
                    if (data.lstChange.length > 0) {
                        data.lstChange.forEach(function (change) {
                            for (var prop in change.data) {
                                if (change.data[prop] != null && change.data[prop][10] == "T" && change.data[prop].length == 24 && change.data[prop].endsWith("Z")) {
                                    try {
                                        change.data[prop] = new Date(change.data[prop])
                                    } catch (e) { }
                                }
                            }
                        })
                        if (data.lstChange.filter(function (o) { return o.type == "insert" }).length > 0) animate = true
                        if (dxGridData.getDataSource() != null) dxGridData.getDataSource().store().push(data.lstChange)

                        //PERF : index des lignes visibles par clé
                        var mapRowVisible = new Map()
                        dxGridData.getVisibleRows().forEach(function (row) { if (row.data) mapRowVisible.set(row.data.cle, row) })
                        var lstRowIndexChange = []
                        data.lstChange.forEach(function (change) {
                            if (change.type == "update") {
                                var row = mapRowVisible.get(change.key)
                                if (typeof row != 'undefined') {
                                    mDeleteTemplate(row.data)
                                    lstRowIndexChange.push(row.rowIndex)
                                }
                            }
                        })
                        if (lstRowIndexChange.length > 0) dxGridData.repaintRows(lstRowIndexChange)
                    }
                }
            );
        })
    }

    function mUpdateRowVisible(idTable, id) {
        var lstRow = []
        var row = dxGridData.getVisibleRows().filter(function (row) { return row.data.id == id && row.data.id_table == idTable })[0]
        if (typeof row != 'undefined') lstRow.push(row)
        if (option.bddCtrl.table.mGetItemFromNom("structures").id_table == idTable || option.bddCtrl.table.mGetItemFromNom("contact").id_table == idTable) {
            switch (idTable) {
                case option.bddCtrl.table.mGetItemFromNom("structures").id_table:
                    lstDataStrcon = option.bddCtrl.getObjet("structures_contact").objetMetier.mGetLstDataStrCon(id, null, function (lst) { mEnd(lst) })
                    //lstDataStrCon = option.bddCtrl.getObjet("structures", id).objetMetier.mGetLstDataStructuresContact()
                    break;
                case option.bddCtrl.table.mGetItemFromNom("contact").id_table:
                    lstDataStrcon = option.bddCtrl.getObjet("structures_contact").objetMetier.mGetLstDataStrCon(null, id, function (lst) { mEnd(lst) })
                    //lstDataStrCon = option.bddCtrl.getObjet("contact", id).objetMetier.mGetLstDataStructuresContact()
                    break;
                default:
                    mEnd([])
                    break;
            }
            function mEnd(lstDataStrCon) {
                var idTableStrCon = option.bddCtrl.table.mGetItemFromNom("structures_contact").id_table
                var setIdStrCon = new Set(lstDataStrCon.map(function (o) { return "" + o.id_structures_contact }))
                lstRow = lstRow.concat(dxGridData.getVisibleRows().filter(function (row) {
                    return row.data.id_table == idTableStrCon && setIdStrCon.has("" + row.data.id)
                }))
            }

        }

        if (lstRow.length > 0) {
            var lstRowIndex = []
            lstRow.forEach(function (row) {
                mDeleteTemplate(row.data)
                lstRowIndex.push(row.rowIndex);
            })
            dxGridData.repaintRows(lstRowIndex)
        }
    }

    var txtSearchLucene = ""
    this.mUpdateSearchLucene = function (txtSearch, dxCtrlRecherche) {
        if (!option.hideEntete) dxGridData.option("dataSource", {
            store: { type: "array", data: [], key: "cle" },
            reshapeOnPush: true,
            pushAggregationTimeout: 0
        })
        txtSearchLucene = txtSearch
        if (!option.hideEntete) dxGridEntete.mChangeSearchLucene(txtSearchLucene, dxCtrlRecherche)
    }

    function mHasTemplate(dataGrid) {
        return mapTemplate.has(mCleTpl(dataGrid.id_table, dataGrid.id))
    }
    function mGetTemplateBase(dataGrid) {
        return mapTemplate.get(mCleTpl(dataGrid.id_table, dataGrid.id))
    }
    function mGetTemplateDisplay(dataGrid) {
        if (typeof option.nomTemplateDisplay == 'undefined') { return mGetTemplateBase(dataGrid) }
        else { return mGetTemplateBase(dataGrid)[option.nomTemplateDisplay] }
    }
    function mGetTemplateIco(dataGrid) {
        if (typeof option.nomTemplateIco == 'undefined') { return mGetTemplateBase(dataGrid) }
        else { return mGetTemplateBase(dataGrid)[option.nomTemplateIco] }
    }
    function mGetTemplatePlus(dataGrid) {
        if (typeof option.nomTemplatePlus == 'undefined') { return mGetTemplateBase(dataGrid) }
        else { return mGetTemplateBase(dataGrid)[option.nomTemplatePlus] }
    }

    function mDeleteTemplate(dataGrid) {
        var templateBase = mGetTemplateBase(dataGrid)
        var idx = lstTemplate.indexOf(templateBase)
        if (idx != -1) {
            lstTemplate.splice(idx, 1)
            mIndexTemplate()
        }
    }

    //PERF : Set/Map au lieu de filter imbriqués (O(n) au lieu de O(n²))
    function mGetLstIdTableIdForLoadingTemplate(lstVisibleRowsData, champ) {
        var dataTop = lstVisibleRowsData[0].data
        var dataBottom = lstVisibleRowsData[lstVisibleRowsData.length - 1].data
        var indexTop = lstCurrentData.indexOf(dataTop)
        const lstAuDessus = indexTop > 0 ? lstCurrentData.slice(Math.max(0, indexTop - nbTemplateAvant), indexTop) : [];
        var indexBottom = lstCurrentData.indexOf(dataBottom)
        const lstEnDessous = lstCurrentData.slice(indexBottom + 1, indexBottom + nbTemplateApres + 1);

        var setTotal = new Set()
        var setAjoute = new Set()
        var lstIdTableId = []
        function mTraite(idTable, id) {
            var k = mCleTpl(idTable, id)
            setTotal.add(k)
            if (!mapTemplate.has(k) && !setAjoute.has(k)) {
                setAjoute.add(k)
                lstIdTableId.push({ id_table: idTable, id: id })
            }
        }

        var sansPagination = !option.bddCtrl.utiCourantParaJson.parametre_general.pagination_grille
        //visibles d'abord
        lstVisibleRowsData.forEach(function (data) { mTraite(data[champ].id_table, data[champ].id) })
        if (sansPagination) {
            lstEnDessous.forEach(function (data) { mTraite(data.id_table, data.id) })
            lstAuDessus.forEach(function (data) { mTraite(data.id_table, data.id) })
        }

        //on purge les templates hors de la fenêtre
        var nbAvant = lstTemplate.length
        lstTemplate = lstTemplate.filter(function (t) { return setTotal.has(mCleTpl(t.id_table_key, t.id_key)) })
        if (lstTemplate.length != nbAvant) mIndexTemplate()

        return lstIdTableId
    }

    function mGetLstIdTableIdForTemplate(lst, champ) {
        var setDeja = new Set()
        var lstIdTableId = []
        lst.forEach(function (data) {
            var k = mCleTpl(data[champ].id_table, data[champ].id)
            if (!setDeja.has(k)) {
                setDeja.add(k)
                lstIdTableId.push({ id_table: data[champ].id_table, id: data[champ].id })
            }
        })
        return lstIdTableId
    }

    this.mReinitState = function () { dxGridEntete.mReinitState(); }
    this.mGetLstData = function () { return ((lstCurrentData == null) ? [] : lstCurrentData) }
    this.mGetLstSelectedData = function () { return ((dxGridData == null) ? [] : dxGridData.getSelectedRowsData()) }
    var lstCurrentData = null
    this.mReloadData = function (lstData, animateOn) {
        idxAnim = 0

        //détection des doublons en un seul passage
        var setCle = new Set()
        var mapDoublon = new Map()
        for (var i = 0; i < lstData.length; i++) {
            var cle = lstData[i].cle
            if (setCle.has(cle)) { mapDoublon.set(cle, (mapDoublon.get(cle) || 1) + 1) }
            else { setCle.add(cle) }
        }
        if (mapDoublon.size > 0) {
            try {
                throw new Error("Doublons dans une grille (" + mapDoublon.size + ") " + JSON.stringify(Array.from(mapDoublon.entries())));
            } catch (e) {
                mTraiteMessageJs("erreurjs", e.message, $(location).attr("href"), 0, null, e, "orange")
            }
        }

        template0LoadedForPagination = false
        animate = ((typeof animateOn == 'undefined') ? true : animateOn)
        lstCurrentData = lstData
        lstTemplate = []
        mapTemplate = new Map()
        lstTemplatePending = {}
        generationTemplate += 1
        if (dxGridData) {
            dxGridData.option("dataSource", {
                store: { type: "array", data: lstCurrentData, key: "cle" },
                reshapeOnPush: true,
                pushAggregationTimeout: 0
            })
        } else {
            window.setTimeout(function () {
                if (dxGridData) {
                    dxGridData.option("dataSource", {
                        store: { type: "array", data: lstCurrentData, key: "cle" },
                        reshapeOnPush: true,
                        pushAggregationTimeout: 0
                    })
                }
            }, 300)
        }
    }

    this.mRefresh = function () {
        if (dxScrollGrid) dxScrollGrid.option("onScroll")({
            element: dxScrollGrid.element(),
            component: dxScrollGrid,
            scrollOffset: { top: 1, left: 0 },
            reachedTop: false,
            reachedRight: false,
            reachedLeft: false,
            reachedBottom: false,
            animate: false
        })
    }

    this.component = function () { return dx; }
    this.element = function () { return container; }

    mConstruit();
}